import { render, staticRenderFns } from "./UDIOutlistDialog.vue?vue&type=template&id=5f875ee6&scoped=true"
import script from "./UDIOutlistDialog.vue?vue&type=script&lang=js"
export * from "./UDIOutlistDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f875ee6",
  null
  
)

export default component.exports